<template>
    <div class="page">
        <toolbar-system></toolbar-system>
        <progress-system :isLoad="system.progress"></progress-system>
        <alertbar-system v-if="system.AlertbarShow != null" :alertbar="system.AlertbarShow"></alertbar-system>
        <v-container v-show="novoFaleConoscoView">
            <v-layout>
                <v-flex>
                    <v-card>
                        <v-card-title>
                            <h1 class="display-1 text-uppercase">Enviar mensagem</h1>
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-card-text>
                            <v-card-text>
                                <v-form>
                                    <v-text-field v-model="faleconosco.topico" color="blue" label="Tópico"></v-text-field>
                                    <v-checkbox v-model="faleconosco.ativo" color="blue" :disabled="true" label="Ativo"></v-checkbox>
                                    <v-textarea v-model="faleconosco.descricao" label="Descrição" color="blue"></v-textarea>
                                </v-form>
                            </v-card-text>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn @click="[novoFaleConoscoView = false, btnFeedback = false]" class="siler" large dark>Cancelar</v-btn>
                            <v-btn @click="createFaleConosco()" class="blue darken-1" large dark>Enviar</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>

        <v-container v-show="novoFeedbackView">
            <v-layout >
                <v-flex >

                    <v-card>
                        <v-card-title>
                            <h1 class="display-1 text-uppercase">Cadastrar Feedback</h1>
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-card-text>
                            <h3>Tópico da mensagem: </h3>  {{faleconosco.topico}}
                            <h3>Descrição da mensagem: </h3>  {{faleconosco.descricao}}
                            <h3>Feedback do respondente: </h3>  {{feedback.texto}}
                            <v-form>
                                <v-textarea v-if="faleconosco.ativo == 1" v-model="feedback.texto" label="Feedback" color="blue"></v-textarea>
                            </v-form>
                        </v-card-text>
                        <v-card-actions>

                            <v-btn @click="[darFeedback(0), novoFeedbackView = false, btnFeedback = false]" class="siler" large dark>Cancelar</v-btn>
                            <v-btn v-if="faleconosco.ativo == 1" @click="atualizarFeedback(faleconosco.id),newFeedback(faleconosco.id)" class="blue darken-1" large dark>Confirmar</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>


        <v-container >
            <v-layout>
                <v-flex xl12>
                    <v-card flat>
                        <v-card-title>
                            <v-autocomplete
                                    color="blue"
                                    label="Pesquise um feedback cadastrado"
                                    :items="faleconoscosSearch"
                                    item-text="Topico"
                                    item-value="IdFaleconosco"
                                    prepend-icon="mdi mdi-database-search"
                                    @change="getFaleconoscoSearch($event)"
                            ></v-autocomplete>
                            <v-btn v-show="cadastrarMensagem"
                                    dark
                                    color="blue"
                                    @click="novoFaleConoscoView = !novoFaleConoscoView"
                            >
                                <v-icon left >mdi mdi-plus</v-icon>Enviar mensagem
                            </v-btn>
                        </v-card-title>
                        <v-card-text>

                            <v-list v-show="listarMensagem">
                            <template v-for="faleconosco in faleconoscos">
                                <v-list-tile :key="faleconosco.index" :id="faleconosco.IdFaleconosco">
                                    <v-list-tile-action>
                                        <v-chip v-if="faleconosco.Ativo == 1" color="orange" outline>Não respondido</v-chip>
                                        <v-chip v-else color="green" outline >Respondido</v-chip>
                                    </v-list-tile-action>
                                    <v-list-tile-content style="width:30%;margin-left:2%">

                                         {{faleconosco.Topico}}

                                    </v-list-tile-content>
                                    <v-list-tile-content style="width:30%">
                                       {{faleconosco.Descricao}}
                                    </v-list-tile-content>
                                    <v-list-tile-action>
                                        <v-btn v-if="faleconosco.Ativo == 1" color="orange" @click="[darFeedback(faleconosco.IdFaleconosco), novoFeedbackView = true, btnFeedback = true]"  dark icon>
                                            <v-icon>mdi mdi-pencil</v-icon>
                                        </v-btn>
                                        <v-btn v-else-if="faleconosco.Ativo == 0" color="green" @click="[darFeedback(faleconosco.IdFaleconosco), novoFeedbackRespondidoView = true]"  dark icon>
                                            <v-icon>mdi mdi-tooltip</v-icon>
                                        </v-btn>
                                        <v-btn v-else color="orange" @click="[darFeedback(faleconosco.IdFaleconosco), novoFeedbackView = true, btnFeedback = true]"  dark icon>
                                            <v-icon>mdi mdi-pencil</v-icon>
                                        </v-btn>
                                    </v-list-tile-action>
                                </v-list-tile>

                                <v-divider :key="faleconosco.index"></v-divider>
                            </template>
                            </v-list>

                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>

    import ToolbarSystem from '../../../components/ToolbarSystem'
    import ProgressSystem from '../../../components/ProgressSystem'
    import AlertbarSystem from '../../../components/AlertbarSystem'

    export default {
        components: {
            ToolbarSystem,
            ProgressSystem,
            AlertbarSystem
        },
        data() {
            return {
                system: {
                    progress: true,
                    AlertbarShow: null
                },
                faleconosco: {
                    topico: null,
                    ativo: true,
                    descricao: null
                },
                feedback: {
                    texto: null
                },
                novoFaleConoscoView: false,
                novoFeedbackView: false,
                usuario: null,
                faleconoscosSearch: null,
                faleconoscos: null,
                feedbacks: null,
                cadastrarMensagem: false,
                listarMensagem: false,
            }
        },

        methods: {
            getFaleconoscos() {
                this.axios.get('admin/faleconosco').then(res => {
                    this.faleconoscosSearch = res.data
                    this.faleconoscos = res.data                    
                }).catch(() => {

                }).finally(() => {
                    this.system.progress = false
                })
            },
            getFeedbacks(idFaleconosco) {
                this.axios.get(`admin/faleconosco/${idFaleconosco}/feedback`).then(res => {
                    this.feedbacks = res.data
                    this.feedbacks.map(elem => {
                        if (elem.IdFaleconosco == idFaleconosco) {
                            this.feedback.texto = elem.Texto

                        }
                    })

                }).finally(() => {
                    this.system.progress = false
                })
            },

            createFaleConosco() {
                this.system.progress = true
                this.axios.post('admin/faleconosco', this.faleconosco).then(res => {
                    this.novoFaleConoscoView = false
                    this.faleconosco.topico = null
                    this.faleconosco.descricao = null

                    this.system.AlertbarShow = {
                        color: 'green',
                        show: true,
                        time: 10000,
                        text: res.data,
                        bottom: false,
                        right: true,
                        multi: true
                    }
                    this.getFaleconoscos()
                }).catch(e => {
                    this.system.AlertbarShow = {
                        color: 'red',
                        show: true,
                        time: 10000,
                        text: e.response.data,
                        bottom: false,
                        right: true,
                        multi: true
                    }
                }).finally(() => {
                    this.system.progress = false
                })
            },
            darFeedback(idFaleconosco) {
                this.novoFeedbackView = true

                    this.faleconoscos.map(elem => {
                        if (elem.IdFaleconosco == idFaleconosco) {
                            this.faleconosco.id = elem.IdFaleconosco
                            this.faleconosco.topico = elem.Topico
                            this.faleconosco.descricao = elem.Descricao
                            this.faleconosco.ativo = elem.Ativo
                        }
                    })
                this.$nextTick(() => {
                    document.getElementById('btnFeedbackShow').classList.add('v-btn--disabled')
                })

                this.getFeedbacks(idFaleconosco)
            },
            atualizarFeedback(idFaleconosco) {
                this.system.progress = true
                this.axios.put(`admin/faleconosco/${idFaleconosco}`, this.faleconosco).then(() => {

                    this.system.AlertbarShow = {
                        color: 'yellow',
                        show: true,
                        time: 10000,
                        text: 'Confirme para enviar o Feedback',
                        bottom: false,
                        right: true,
                        multi: true
                    }

                }).catch(e => {
                    this.system.AlertbarShow = {
                        color: 'red',
                        show: true,
                        time: 10000,
                        text: e.response.data,
                        bottom: false,
                        right: true,
                        multi: true
                    }
                }).finally(() => {
                    this.system.progress = false
                })
            },
            getFaleconoscoSearch(id){
                this.axios.get(`admin/faleconosco/${id}`).then(res => {
                    this.faleconoscos = []
                    this.faleconoscos.push(res.data[0])                    
                }).catch(e => {
                    this.system.progress = false
                    this.system.AlertbarShow = {
                        show: true,
                        time: 10000,
                        text: e.response.data,
                        bottom: false,
                        right: true,
                        multi: true
                    }
                }).finally(() => {
                    this.system.progress = false
                })
            },
            newFeedback(idFaleconosco) {
                this.system.progress = true
                this.axios.post(`admin/faleconosco/${idFaleconosco}/feedback/`, this.feedback).then(() => {
                    this.novoFeedbackView = false
                    this.feedback.texto = null


                    this.system.AlertbarShow = {
                        color: 'green',
                        show: true,
                        time: 10000,
                        text: 'Feedback enviado com sucesso',
                        bottom: false,
                        right: true,
                        multi: true
                    }
                    this.getFaleconoscos()
                }).catch(e => {
                    this.system.AlertbarShow = {
                        color: 'red',
                        show: true,
                        time: 10000,
                        text: e.response.data,
                        bottom: false,
                        right: true,
                        multi: true
                    }
                }).finally(() => {
                    this.system.progress = false
                })

            },
            checkUser(){
                if(this.$route.path == '/admin' || this.$route.name == 'faleconoscosAdmin'){
                    this.cadastrarMensagem=false
                    this.listarMensagem=true

                }
                if(this.$route.path == '/aluno' || this.$route.name == 'faleconoscosAluno'){
                    this.listarMensagem=false
                    this.cadastrarMensagem=true
                }
                },
            getUser () {
                this.axios.get('user').then(res => {
                    this.usuario = res.data
                    console.dir(res.data)
                }).catch(() => {

                }).finally(() => {
                    this.system.progress = false
                })
            }
            },



        mounted(){
        this.getFaleconoscos()
            this.getFeedbacks()
            this.checkUser()
            this.getUser()

        }
    }




</script>

